import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChartBox = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeMiterlimit: 10
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Laag-1",
		"serif:id": "Laag 1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M19.195,21.678l-14.481,0c-1.461,0 -2.644,-1.183 -2.644,-2.644l0,-14.481c0,-1.461 1.183,-2.644 2.644,-2.644l14.481,0c1.461,0 2.644,1.183 2.644,2.644l0,14.481c0,1.461 -1.183,2.644 -2.644,2.644Z",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.338,18.221l0,-5.342",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.955,18.22l0,-12.026",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.571,18.221l0,-8.53",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			})
		]
	})
});
export default SvgChartBox;
